module.exports = __webpack_public_path__ + "static/1-dfe563a6d3a66edb68c9d1c857c3d196.jpg";